import { makeMultiSearch, makeSearch } from "../../UI/Search/Search";
import RoleService from "../../../Services/Role.service";
const makeSearchArgs = {
    loadOptions: (search, options) => {
        return RoleService.search(Object.assign(Object.assign({}, options), { name: search, isDeleted: false })).then(({ data }) => data);
    },
    label: "name",
    value: "id",
};
export const RoleSearch = makeSearch(makeSearchArgs);
export const RoleMultiSearch = makeMultiSearch(makeSearchArgs);
